import { defineElement, FC, onDidLoad, useElement, useListen } from '@atomify/hooks';
import DetectTouch from '@source/utilities/is-touch';

const CLASS_CROP_VERTICALLY = 'hero-hotspot--crop-vertically';

const HeroHotspot: FC = ({ element }) => {
    const image = useElement<HTMLImageElement>('[js-hook-hero-hotspot-image]');
    const container = useElement<HTMLElement>('[js-hook-hero-hotspot-container]');

    let containerBounds: DOMRect;
    let imageBounds: DOMRect;

    onDidLoad(update);
    useListen(image, 'load', update);
    useListen(window, 'resize', update);

    useListen(container, 'mousemove', (e: MouseEvent) => {
        const mouseX = e.clientX;

        if (!DetectTouch.isTouchDevice) {
            setScroll(mouseX);
        }
    });

    function update() {
        // Update bounds
        containerBounds = container.current!.getBoundingClientRect();
        imageBounds = image.current!.getBoundingClientRect();

        // If the image is higher than the container, vertically crop the image
        if (isImageHigher()) {
            element.classList.add(CLASS_CROP_VERTICALLY);
        } else {
            element.classList.remove(CLASS_CROP_VERTICALLY);
        }
    }

    function isImageHigher() {
        const containerAspectRatio = containerBounds.width / containerBounds.height;
        const imageAspectRatio = imageBounds.width / imageBounds.height;

        return imageAspectRatio < containerAspectRatio;
    }

    function setScroll(mouseX: number) {
        const diff = imageBounds.width - containerBounds.width;
        const mouseNormalizedX = mouseX / containerBounds.width;

        container.current!.scrollLeft = diff * mouseNormalizedX;
    }
};

defineElement('hero-hotspot', HeroHotspot);
